import req from "../http";

const contract = {
  // 取得 合約清單
  getContract(matchId) {
    return req("get", `/Recruitment/Contract/List/${matchId}`);
  },

  // 儲存 合約簽名
  putContract(params) {
    return req("put", "/Recruitment/Contract", params);
  },

  // 下載 合約 PDF
  downloadContractPDF(params) {
    return req("post", "/Recruitment/Contract/PDF",  params, { responseType: "blob" });
  },
};

export default contract;